import { z } from "zod";

export const brokerSchema = z.object({
	id: z.string().nonempty(),
	email: z.string().email(),
	firstName: z.string().nonempty(),
	lastName: z.string().nonempty(),
	phone: z.string().optional(),
});

export const newBrokerSchema = brokerSchema.omit({
	id: true,
});

export type TBroker = z.infer<typeof brokerSchema>;
export type TNewBroker = z.infer<typeof newBrokerSchema>;
